import './App.css';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react';
import { ClipLoader } from "react-spinners";
import axios from 'axios';
import i18n from './lang/i18n';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollarSign, faAt } from "@fortawesome/free-solid-svg-icons";

import Header from './Nav/header';
import Footer from './Nav/footer';
import Main from './Pages/main';
import Character from './Pages/character';
import AirDrop from './Pages/airdrop';
import Friends from './Pages/friends';
import Setting from './Pages/setting';
import Memories from './Pages/memories';
import RandomBox from './Pages/randomBox';
import Coupons from './Pages/coupons';
import CouponDetail from './Pages/couponsDetail';

import { useDispatch, useSelector } from 'react-redux';
import {
  changeBackgroundImg, changeCircleImg, changeEnergy, changeFullScreenBtn, changeGold, changeHaptic, changeJackpotImg, changeLanguages, changeMobileType, changePlusEnergy, changeSound, checkDuplicateLogins, checkJackpot, checkjackpotCheck, checkJWT, checkLimitUpgrade,
  checkLimitUpgradeValue, checkMyData, checkMySkin, checkTapUpgrade, checkTapUpgradeValue
} from './store';

import WebApp from '@twa-dev/sdk';
import { QRCodeCanvas } from 'qrcode.react';
import useWindowSize from './hook/useWindowSize'

function App() {
  let DuplicateLogins = useSelector((state) => { return state.DuplicateLogins.value })
  let FullScreenBtn = useSelector((state) => { return state.FullScreenBtn.value })
  let backgroundImg = useSelector((state) => { return state.backgroundImg.value })

  const [loading, setLoading] = useState(0);
  const [isImageLoaded, setIsImageLoaded] = useState(false); // 이미지 로딩 상태 추가
  const [loadingText, setLoadingText] = useState("Loading...")

  const [checkWeb, setCheckWeb] = useState(false)

  const { Rwidth, Rheight } = useWindowSize();

  let navigate = useNavigate()
  let dispatch = useDispatch()
  let location = useLocation();

  const handleImageLoad = () => {
    setIsImageLoaded(true); // 이미지가 로드되면 상태를 업데이트합니다.
  };

  const platform = window.Telegram.WebApp.platform;
  const fullPath = location.pathname + location.hash;

  useEffect(() => {
    if (['android', 'android_x', 'ios', 'tdesktop'].includes(platform)) {
      if (fullPath === '/') {
        window.Telegram.WebApp.BackButton.hide();
      } else {
        window.Telegram.WebApp.BackButton.show();
      }
    }
  }, [fullPath, platform]);

  useEffect(() => {
    if (['android', 'android_x', 'ios', 'tdesktop'].includes(platform)) {
      const handler = () => {
        navigate(-1);
      };

      window.Telegram.WebApp.BackButton.onClick(handler);

      return () => {
        window.Telegram.WebApp.BackButton.offClick(handler); // 특정 핸들러만 제거
      };
    }
  }, [navigate, platform]);

  // 미니앱 스크롤 변경
  window
    .TelegramWebviewProxy
    .postEvent('web_app_setup_swipe_behavior', JSON.stringify({ allow_vertical_swipe: false }));

  // 미니앱 헤더 색상 변경
  const data2 = JSON.stringify({ color: "#000000" });
  window
    .TelegramWebviewProxy
    .postEvent('web_app_set_header_color', data2);

  // 미니앱 하단 색상 변경
  const data3 = JSON.stringify({ color: "#000000" });
  window
    .TelegramWebviewProxy
    .postEvent('web_app_set_background_color', data3);

  // 미니앱 헤더 뒤로가기 버튼
  // const data = JSON.stringify({ is_visible: true });
  // window
  //   .TelegramWebviewProxy
  //   .postEvent('web_app_setup_back_button', data);

  useEffect(() => {
    let obj = localStorage.getItem('FullScreen')
    dispatch(changeFullScreenBtn(obj == "true" ? true : false))
    if (obj == "true") {
      window
        .TelegramWebviewProxy
        .postEvent('web_app_request_fullscreen', true);
    }

    navigate("/");

    const objString = localStorage.getItem("language");
    if (objString) {
      onChangeLang(objString)
    }
    else {
      onChangeLang("en-US")
    }

    let hapticCheck = localStorage.getItem('haptic')
    let soundCheck = localStorage.getItem('sound')

    if (hapticCheck) dispatch(changeHaptic(hapticCheck == "true" ? true : false))
    if (soundCheck) dispatch(changeSound(soundCheck == "true" ? true : false))

    // 텔레그램 SDK 초기화
    if (window.Telegram) {
      const tg = window.Telegram.WebApp;
      tg.ready(); // SDK 준비 완료
      tg.expand();

      WebApp.setHeaderColor('#000000');
      WebApp.setBottomBarColor('#000000');

      // if (tg?.platform == "tdesktop" || tg?.platform == "desktop" || tg?.platform == "web") {
      //   setCheckWeb(true)
      // }
      // else {
      //   setCheckWeb(false)

      // initData로부터 사용자 인증 정보 가져오기
      let initData = tg.initData;

      if (tg?.platform == "ios") {
        dispatch(changeMobileType(1))
      }
      else {
        dispatch(changeMobileType(0))
      }

      if (initData) {
        const storedGoldLogs = JSON.parse(localStorage.getItem("goldLogs")) || [];
        const storedEnergyLogs = JSON.parse(localStorage.getItem("energyLogs")) || [];

        let goldCheck = storedGoldLogs.length == 0 ? true : GoldBulk(initData, storedGoldLogs);
        let EnergyCheck = storedEnergyLogs.length == 0 ? true : EnergyBulk(initData, storedEnergyLogs);

        if (goldCheck && EnergyCheck) {
          // 1) 처음(마운트 시) 즉시 ServerCheck 호출
          ServerCheck(initData, 0);

          // 2) 오늘 ~ 자정까지 남은 시간을 계산
          const now = new Date();
          const nextMidnight = new Date();
          nextMidnight.setHours(24, 0, 0, 0); // 오늘 24:00(= 내일 00:00)
          const timeUntilMidnight = nextMidnight - now; // 밀리초 단위

          let dailyInterval; // 매일 자정마다 실행할 setInterval ID를 담을 변수

          // 3) 자정에 한 번 실행 후, 이후 매일 24시간 간격으로 반복
          const midnightTimeout = setTimeout(() => {
            ServerCheck(initData, 1); // 자정에 호출

            // 자정 이후 매 24시간마다 호출
            dailyInterval = setInterval(() => {
              ServerCheck(initData, 1);
            }, 24 * 60 * 60 * 1000);
          }, timeUntilMidnight);

          // 4) 컴포넌트 언마운트 시점에 타이머/인터벌 정리
          return () => {
            clearTimeout(midnightTimeout);
            if (dailyInterval) {
              clearInterval(dailyInterval);
            }
          };
        }
      }
      // }
    }
  }, []);


  const [appHeight, setAppHeight] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight;

      if (windowHeight <= 700) {
        setAppHeight(true);
      } else {
        setAppHeight(false);
      }
    };
    handleResize();
  }, [Rheight]);

  const onChangeLang = (e) => {
    i18n.changeLanguage(e);
    dispatch(changeLanguages(e));
  };

  const GoldBulk = async (token, storedGoldLogs) => {
    await axios.post(process.env.REACT_APP_API + '/api/gold/bulk', {
      goldBulk: storedGoldLogs
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then((response) => {
      let tmp = response.data
      if (tmp?.code == 1000) {
        localStorage.removeItem("goldLogs");
        return true
      }
      return false
    }).catch((error) => {
      if (error?.status === 999) {
        dispatch(checkDuplicateLogins(true))
      }
      else {
        console.log(error)
      }
    })
  };

  const EnergyBulk = async (token, storedEnergyLogs) => {
    await axios.post(process.env.REACT_APP_API + '/api/energy/bulk', {
      energyBulk: storedEnergyLogs
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then((response) => {
      let tmp = response.data
      if (tmp?.code == 1000) {
        localStorage.removeItem("energyLogs");
        return true
      }
      return false
    }).catch((error) => {
      if (error?.status === 999) {
        dispatch(checkDuplicateLogins(true))
      }
      else {
        console.log(error)
      }
    })
  };

  const ServerCheck = async (token, n) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API + '/api/status/complete');
      const tmp = response.data;

      if ((tmp?.code === 1000 || tmp?.code === -1000) && Array.isArray(tmp.data)) {
        const items = tmp.data;
        const itemCount = items.length;

        // 아이템이 없는 경우
        if (itemCount === 0) {
          if (tmp.code === 1000) {
            fetchUserData(token, 0);
          } else {
            setLoadingText("실패(데이터가 없습니다)");
          }
          return;
        }

        const dataPoints = itemCount * 2;

        let randomValues = [];
        for (let i = 0; i < dataPoints; i++) {
          const rand = 0.05 + Math.random() * 0.5;
          randomValues.push(rand);
        }

        const sumOfRandoms = randomValues.reduce((acc, val) => acc + val, 0);
        const scaleFactor = 4500 / sumOfRandoms;

        randomValues = randomValues.map(val => val * scaleFactor);

        for (let i = 0; i < itemCount; i++) {
          setLoadingText(`${items[i].step}`);
          await new Promise(resolve =>
            setTimeout(resolve, randomValues[i * 2])
          );

          setLoadingText(`${items[i].detail}`);
          await new Promise(resolve =>
            setTimeout(resolve, randomValues[i * 2 + 1])
          );
        }

        if (tmp.code === 1000) {
          fetchUserData(token, 0);
        } else {
          setLoadingText("실패했습니다. (code -1000)");
        }
      } else {
        console.log("code가 1000/-1000이 아니거나 data가 배열이 아님:", tmp);
      }
    } catch (error) {
      if (error?.status === 999) {
        dispatch(checkDuplicateLogins(true));
      } else {
        console.error(error);
      }
    }
  };

  // 사용자 데이터를 가져오기 위한 API 호출 함수
  const fetchUserData = async (token, n) => {
    await axios.get(process.env.REACT_APP_API + `/api/user?`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      let tmp = response.data
      if (tmp?.code == 1000) {
        console.log(tmp?.data)

        dispatch(checkJWT(tmp?.data?.jwt ?? ""))
        dispatch(checkMySkin(tmp?.data?.skin ?? []))
        dispatch(checkMyData(tmp?.data?.user ?? []))
        dispatch(checkTapUpgrade(tmp?.data?.power[0].up_level ?? 1))
        dispatch(checkLimitUpgrade(tmp?.data?.power[1].up_level ?? 1))
        dispatch(checkTapUpgradeValue(tmp?.data?.power[0].up_value ?? 1))
        dispatch(checkLimitUpgradeValue(tmp?.data?.power[1].up_value ?? 1))
        dispatch(changePlusEnergy(tmp?.data?.energy ?? []))
        dispatch(changeJackpotImg(tmp?.data?.jackpotImg ?? []))
        dispatch(changeCircleImg(tmp?.data?.circle[0]?.circle_url ?? []))
        dispatch(changeBackgroundImg(tmp?.data?.background[0]?.bg_url ?? []))

        dispatch(changeGold(tmp?.data?.user?.user_gold ?? 0))
        dispatch(changeEnergy(tmp?.data?.user?.user_last_energy ?? 100))

        if (n === 0) {
          setTimeout(() => {
            setLoading(1);
          }, 500);
        }
      }
    }).catch((error) => {
      if (error?.status === 999) {
        dispatch(checkDuplicateLogins(true))
      }
      else {
        console.log(error)
      }
    })
  };

  const [loca, setLoca] = useState(0)

  useEffect(() => {
    if (location.pathname == '/') setLoca(0)
    else if (location.pathname == '/character') setLoca(1)
    else if (location.pathname == '/randomBox') setLoca(1)
    else setLoca(2)
  }, [location])

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const updateDimensions = () => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    if (windowWidth <= 450) {
      // 가로가 450 이하일 경우 화면 너비를 100%로 설정
      setDimensions({
        width: windowWidth,
        height: windowHeight,
      });
    } else if (windowWidth / 1 < windowHeight / 2) {
      // 가로가 더 작은 경우: 가로를 기준으로 계산
      setDimensions({
        width: windowWidth,
        height: windowWidth * 2, // 1:2 비율
      });
    } else {
      // 세로가 더 작은 경우: 세로를 기준으로 계산
      setDimensions({
        width: windowHeight / 2, // 1:2 비율
        height: windowHeight,
      });
    }
  };

  useEffect(() => {
    // 초기 크기 설정
    updateDimensions();
  }, [Rheight]);

  return (
    <div
      className='ratio'
      style={{
        height: `${dimensions.height}px`,
        width: `${dimensions.width}px`,
        backgroundColor: "lightblue",
      }}
    >
      <div className="App">
        {
          DuplicateLogins
            ?
            <div className='web'>
              <div className='web-box'>
                <div style={{ fontSize: "26px", fontWeight: "700", marginBottom: '20px' }}>Duplicate login attempts detected.</div>
                <div style={{ fontSize: "26px", fontWeight: "700", }}>To continue using this device,</div>
                <div style={{ fontSize: "26px", fontWeight: "700", marginBottom: '20px' }}>please refresh.</div>
                <div style={{ fontSize: "24px", fontWeight: "400" }}><FontAwesomeIcon icon={faAt} style={{ fontSize: '22px', fontWeight: "400" }} />hbMini_bot</div>
              </div>
            </div>
            :
            checkWeb
              ?
              <div className='web'>
                <div className='web-box'>
                  <div style={{ fontSize: "26px", fontWeight: "700" }}>Play on your mobile</div>
                  <div className='web-qr'>
                    <QRCodeCanvas value={"https://t.me/hbMini_bot"} style={{ width: '100%', height: '100%' }} />
                  </div>
                  <div style={{ fontSize: "24px", fontWeight: "400" }}><FontAwesomeIcon icon={faAt} style={{ fontSize: '22px', fontWeight: "400" }} />hbMini_bot</div>
                </div>
              </div>
              :
              loading === 0 ? (
                <div className='loading'>
                  {isImageLoaded && (
                    <>
                      <div className='loading-3'>
                        <ClipLoader
                          color="#F5AC1D"
                          size={70}
                          cssOverride={{ borderWidth: "4px", marginBottom: "0px" }}
                          speedMultiplier={0.3}
                        />
                        <div style={{ fontSize: "25px" }}>Loading...</div>
                        <div style={{ height: "40px" }}>{loadingText}</div>
                      </div>
                      <div className='loading-4'>
                        <div style={{ fontSize: "38px", fontWeight: "700", marginBottom: "10px" }}>We did it!</div>
                        <div className='loading-4-1' style={{ marginBottom: "10px" }}><FontAwesomeIcon icon={faDollarSign} />SEAPT</div>
                        <div style={{ marginBottom: "15px", fontWeight: "400", fontSize: "14px" }}>token is on the market</div>
                        <div style={{ color: "#b9b9b9", fontSize: "14px" }}>Stay tuned</div>
                        <div style={{ marginBottom: appHeight ? "0" : "15px" }}>More info in official channels</div>
                        {
                          appHeight
                            ?
                            ""
                            :
                            <div className='loading-5'>
                              <div className='loading-5-1' onClick={() => window.open('https://t.me/')}><img src='/img/telegram.svg' style={{ width: "25px" }} /></div>
                              <div className='loading-5-1' onClick={() => window.open('https://youtube.com/')}><i className="fa-brands fa-youtube"></i></div>
                              <div className='loading-5-1' onClick={() => window.open('https://x.com/')}><i className="fa-brands fa-x-twitter"></i></div>
                            </div>
                        }
                      </div>
                    </>
                  )}
                  {/* <img className='img' src='/newImg/dog_splish.png' onLoad={handleImageLoad} style={{ pointerEvents: "none" }} /> */}
                  <img className='img' src='/newImg/splash_03(unused)(3000x5372).png' onLoad={handleImageLoad} style={{ pointerEvents: "none" }} />
                </div>
              ) : (
                <>
                  {loca === 0 && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${backgroundImg})`,
                        backgroundSize: "cover", // 이미지를 화면에 맞게 표시
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        zIndex: 1, // 다른 요소 아래로 배치
                      }}
                    ></div>
                  )}
                  {loca < 2 && <Header />}
                  <Footer />
                  <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/character" element={<Character />} />
                    <Route path="/airdrop" element={<AirDrop />} />
                    <Route path="/friends" element={<Friends />} />
                    <Route path="/setting" element={<Setting />} />
                    <Route path="/memories" element={<Memories />} />
                    <Route path="/randomBox" element={<RandomBox />} />
                    <Route path="/coupons" element={<Coupons />} />
                    <Route path="/couponsDetail/:couponId" element={<CouponDetail />} />

                    {/* <Route path="*" element={<Navigate to="/" />} /> */}
                  </Routes>
                </>
              )}
      </div>
    </div>
  );
}

export default App;
